import { render } from "./ShadowCardInfo.vue?vue&type=template&id=f881a7ca&scoped=true"
import script from "./ShadowCardInfo.vue?vue&type=script&lang=js"
export * from "./ShadowCardInfo.vue?vue&type=script&lang=js"

import "./ShadowCardInfo.vue?vue&type=style&index=0&id=f881a7ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f881a7ca"]])

export default __exports__